<template lang="pug">
.dawn-tab(v-show='isActive')
  slot
</template>

<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

export default {
  name: 'ed-tab',

  props: {
    title    : { type: String, required: true },
    active   : { type: Boolean, default: false },
    completed: { type: Boolean, default: false },
    icon: Array
  },

  data() {
    return {
      isActive: false,
      isCompleted: false
    }
  },

  computed: {
    href() { return '#' + this.$route.path + '#' + this.title.toLowerCase().replace(/ /g, '-') },
    section() { return '#' + this.title.toLowerCase().replace(/ /g, '-') },
    iconClass() { return this.icon[0] + ' fa-' + this.icon[1] }
  },

  mounted() {
    this.isActive = this.active
    this.isCompleted = this.completed
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.dawn-tab {
  padding-left: .75em;
  padding-right: .75em;
}

</style>



// WEBPACK FOOTER //
// edTab.vue?f374f9f4